
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i0s3_mj90e_99",
  "header": "awsui_header_1i0s3_mj90e_134",
  "full-page": "awsui_full-page_1i0s3_mj90e_134",
  "content": "awsui_content_1i0s3_mj90e_138",
  "error": "awsui_error_1i0s3_mj90e_142",
  "footer": "awsui_footer_1i0s3_mj90e_146",
  "actions-section": "awsui_actions-section_1i0s3_mj90e_150",
  "secondary-actions": "awsui_secondary-actions_1i0s3_mj90e_159",
  "actions": "awsui_actions_1i0s3_mj90e_150"
};
  